import { IS_LOADING, IS_LOADED, SHOW_ERROR, CLEAR_ERROR, USER_REGISTERED, USER_LOGIN, REMOVE_TOKEN, UPDATE_USER, CHANGE_PAGE, SAVE_OPERATORID, CHANGE_LANGUAGE, CHANGE_NAV, CHANGE_COUNTER, SEND_FEEDBACK } from "../actions/type";
import i18n from "../../i18n";

// Function to add our give data into cache
// const addDataIntoCache = (cacheName, url, response) => {
// 	// Converting our response into Actual Response form
// 	const data = new Response(JSON.stringify(response));

// 	if ('caches' in window) {
// 		// Opening given cache and putting our data into it
// 		caches.open(cacheName).then((cache) => {
// 			cache.put(url, data);
// 		});
// 	}
// };

// const getCacheData = (cacheName, url) => {
// 	caches.open(cacheName)
// 	.then((cache) => {
// 		cache.match(url)
// 		.then(res => res.json())
// 			.then(data => {
// 				console.log(data);
// 			})
// 			.catch(err => {
// 				console.log(err)
// 			})
// 	})
// 	.catch(err => {
// 		console.log(err)
// 	})
// }

const initState = {
	isLoading: false,
	error: null,
	token: localStorage.getItem("laundry-user"),
	isAuthenticated: false,
	user: null,
	authProgress: "landing",
	operatorId: localStorage.getItem("operatorId"),
	language: localStorage.getItem("language") || window.navigator.language.substring(0, 2),
	nav: "stamp",
	modalCounter: localStorage.getItem("counter") || 0
};

const userReducer = (state = initState, action) => {
	// console.log(action);
	switch (action.type) {
		case IS_LOADING:
			return {
				...state,
				isLoading: true
			};
		case IS_LOADED:
			return {
				...state,
				isLoading: false
			};
		case SHOW_ERROR:
			return {
				...state,
				error: action.payload
			};
		case CLEAR_ERROR:
			return {
				...state,
				error: null
			};
		case CHANGE_PAGE:
			return {
				...state,
				authProgress: action.payload,
				error: null
			};
		case CHANGE_NAV:
			return {
				...state,
				nav: action.payload,
				error: null
			};
		case USER_REGISTERED:
			return {
				...state,
				authProgress: action.payload.login && !action.payload.register ? "login" : action.payload.register && !action.payload.login ? "register" : "landing"
			};
		case USER_LOGIN:
			localStorage.setItem("laundry-user", action.payload.token);
			return {
				...state,
				user: action.payload.user,
				token: action.payload.token,
				isAuthenticated: true,
				authProgress: "landing"
			};
		case UPDATE_USER:
			if (action.payload.type === "image") {
				return {
					...state,
					user: {
						...state.user,
						profilePicture: action.payload.data
					}
				};
			} else if (action.payload.type === "name") {
				return {
					...state,
					user: {
						...state.user,
						name: action.payload.data
					}
				};
			} else if (action.payload.type === "email") {
				return {
					...state,
					user: {
						...state.user,
						email: action.payload.data
					}
				};
			} else if (action.payload.type === "stamp") {
				return {
					...state,
					user: {
						...state.user,
						...action.payload.data
					}
				};
			}
			break;
		case REMOVE_TOKEN:
			localStorage.removeItem("laundry-user");
			localStorage.removeItem("counter");
			return {
				...state,
				token: null,
				isLoading: false,
				error: null,
				isAuthenticated: false,
				user: null,
				authProgress: "landing",
				modalCounter: 0
			};
		case SAVE_OPERATORID:
			localStorage.setItem("operatorId", action.payload);
			//localStorage.setItem("operatorId", "5f047d87fefcf6715c9bd526");
			//addDataIntoCache('operatorId', `https://${window.location.hostname}`, action.payload)
			return {
				...state,
				operatorId: action.payload
			};
		case CHANGE_LANGUAGE:
			localStorage.setItem("language", action.payload);
			i18n.changeLanguage(action.payload);
			return {
				...state,
				language: action.payload
			};
		case CHANGE_COUNTER:
			localStorage.setItem("counter", action.payload);
			return {
				...state,
				modalCounter: action.payload
			};
		case SEND_FEEDBACK:
			return {
				...state,
				number: action.payload.number,
				location: action.payload.location,
				comment: action.payload.comment
			}
		default:
			return state;
	}
};

export default userReducer;
